mutation DisconnectStripe {
  disconnectStripe {
    id
    paymentSettings {
      publishableKey
      secretKeyMask
      connectedAt
    }
  }
}
